import { fetchPlaybooks, fetchRecommendedPlaybooks, fetchPlaybooksWithRecommendations } from './cardListActionTypes';
export const initialState = {
  loading: true,
  playbooks: {
    offset: 0,
    results: [],
    total: 0,
    hoistedRecommendations: []
  },
  requestedPlaybooks: {
    offset: 0
  },
  searchText: '',
  searchFailed: false,
  recommendationsFailed: false,
  cardListView: 'ALL_PLAYBOOKS'
};
export function playbooksCardListReducer(state, action) {
  switch (action.type) {
    case fetchPlaybooks.pending.type:
      return Object.assign({}, state, {
        requestedPlaybooks: {
          offset: action.payload.offset
        },
        searchText: action.payload.searchText,
        loading: true
      });
    case fetchRecommendedPlaybooks.pending.type:
      return Object.assign({}, state, {
        loading: true
      });
    case fetchRecommendedPlaybooks.fulfilled.type:
      return Object.assign({}, state, {
        loading: false,
        playbooks: Object.assign({}, state.playbooks, {
          hoistedRecommendations: action.payload.map(playbook => ({
            recommendationType: 'RULE',
            playbook
          }))
        })
      });
    case fetchPlaybooks.fulfilled.type:
      return Object.assign({}, state, {
        loading: false,
        playbooks: Object.assign({}, action.payload, {
          hoistedRecommendations: state.playbooks.hoistedRecommendations,
          results: action.payload.results.map(res => ({
            recommendationType: 'NONE',
            playbook: res
          }))
        })
      });
    case fetchPlaybooks.rejected.type:
      return Object.assign({}, state, {
        searchFailed: true,
        loading: false
      });
    case fetchRecommendedPlaybooks.rejected.type:
      return Object.assign({}, state, {
        recommendationsFailed: true,
        loading: false
      });
    case fetchPlaybooksWithRecommendations.pending.type:
      return Object.assign({}, state, {
        requestedPlaybooks: {
          offset: action.payload.offset
        },
        searchText: action.payload.searchText,
        cardListView: action.payload.searchText.length > 0 ? 'ALL_PLAYBOOKS' : state.cardListView,
        loading: true
      });
    case fetchPlaybooksWithRecommendations.fulfilled.type:
      {
        return Object.assign({}, state, {
          playbooks: action.payload,
          cardListView: action.payload.hoistedRecommendations.length === 0 ? 'ALL_PLAYBOOKS' : state.cardListView,
          loading: false
        });
      }
    case fetchPlaybooksWithRecommendations.rejected.type:
      return Object.assign({}, state, {
        recommendationsFailed: true,
        searchFailed: true,
        loading: false
      });
    case 'SWITCH_TO_CARDLIST_VIEW':
      return Object.assign({}, state, {
        cardListView: action.view
      });
    default:
      return state;
  }
}